<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcombobox from "../../FormComponet/formcombobox.vue";

import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import ORenkAciklamalari from "@/models/ORenkAciklamalari";
import moment from "moment";
export default {
  mixins: [Api, Sabit, ORenkAciklamalari],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          this.Post("ORenkAciklamalari", this.FormData).then((res) => {
            if (res) {
                this.FormData = this.ORenkAciklamalariData
                this.$emit("TableUpdate");
                this.$bvModal.hide("ORenkAciklamalari");
            }
          });
        } else {
          this.Update("ORenkAciklamalari", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.ORenkAciklamalariData
              this.$emit("TableUpdate");
              this.$bvModal.hide("ORenkAciklamalari");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="ORenkAciklamalari"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('ORenkAciklamalari.AddEdit.FormTitleEdit')
          : $t('ORenkAciklamalari.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">  
         <formcombobox
          :title_position="'d-block'"
          :labels_lg="8"
          :FormDataType="FormDataType.Renk"
          :Value="FormData.Renk"
          :v="$v.FormData.Renk"
          @input="FormData.Renk = $event"
        />
        <forminput
          :FormDataType="FormDataType.Aciklama"
          :Value="FormData.Aciklama"
          :v="$v.FormData.Aciklama"
          @input="FormData.Aciklama = $event"
        />
       

        <button class="btn btn-primary" type="submit">
          {{ $t("ORenkAciklamalari.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
